import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../../../shared/shared.module";
import { TableModule } from "primeng/table";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { ImageModule } from "primeng/image";
import { PaginatorModule } from "primeng/paginator";
import { ButtonModule } from "primeng/button";
import { RippleModule } from "primeng/ripple";
import { DialogModule } from "primeng/dialog";
import { SplitButtonModule } from "primeng/splitbutton";
import { TieredMenuModule } from "primeng/tieredmenu";
import { TooltipModule } from "primeng/tooltip";
import { ConfirmationService, MessageService } from 'primeng/api';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from "./dashboard-routing.module";

import { WelcomeComponent } from "./welcome/welcome.component";
import { StatusComponent } from "./status/status.component";
import { OverallBalanceComponent } from "./overall-balance/overall-balance.component";
import { RecentOrdersComponent } from "./recent-orders/recent-orders.component";
import { ActivityComponent } from "./activity/activity.component";
import { RecentSalesComponent } from "./recent-sales/recent-sales.component";
import { TimelineComponent } from "./timeline/timeline.component";
import { PurchaseAccountComponent } from "./purchase-account/purchase-account.component";
import { TotalUsersComponent } from "./total-users/total-users.component";
import { FollowersGrowthComponent } from "./followers-growth/followers-growth.component";
import { PaperNoteComponent } from "./paper-note/paper-note.component";
import { OrdersProfitComponent } from "./orders-profit/orders-profit.component";
import { OrdersComponent } from "./orders-profit/orders/orders.component";
import { ProductStatusChartBoxComponent } from "./product-status-chart-box/product-status-chart-box.component";
import { ProfitComponent } from "./orders-profit/profit/profit.component";
import { NgApexchartsModule } from 'ng-apexcharts';
import { UsersStoredComponent } from "./users-stored/users-stored.component";








@NgModule({
    declarations: [
        DashboardComponent,
        WelcomeComponent,
        StatusComponent,
        OverallBalanceComponent,
        RecentOrdersComponent,
        ActivityComponent,
        RecentSalesComponent,
        TimelineComponent,
        PurchaseAccountComponent,
        TotalUsersComponent,
        FollowersGrowthComponent,
        PaperNoteComponent,
        OrdersProfitComponent,
        OrdersComponent,
        ProductStatusChartBoxComponent,
        ProfitComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        DashboardRoutingModule,
        UsersStoredComponent,
        TableModule, CheckboxModule, ConfirmDialogModule,
        DynamicDialogModule, ToastModule, ToolbarModule, FormsModule, InputTextModule,
        ImageModule, PaginatorModule, ButtonModule, RippleModule, DialogModule, SplitButtonModule,
        TieredMenuModule, TooltipModule,
        ConfirmDialogModule,
        ToastModule,
         NgApexchartsModule,

    ],
    providers: [MessageService, ConfirmationService, DialogService]

})
export class DashboardModule { }
